import snackBarReducer from '../modules/reducers/snackBar/reducers'
import accessibilityReducer from '../modules/reducers/accessibility/reducers'
import modalReducer from '../components/dialog/reducer/reducers'

export default {
	snackBar: snackBarReducer,
    modal: modalReducer,
	accessibility: accessibilityReducer
}
